import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const SmartsuppChat = () => {
    const { pathname } = useLocation();

    useEffect(() => {
        const allowedPaths = ['/', '/support', '/contact'];
        const currentPath = pathname.replace(/\/$/, '') || '/';

        const removeChat = () => {
            document.getElementById('smartsupp-loader')?.remove();
            document.querySelectorAll(
                '[id^="smartsupp"], [class*="smartsupp"], iframe[src*="smartsupp"]'
            ).forEach((element) => element.remove());
        };

        const showChat = () => {
            if (typeof window.smartsupp === 'function') {
                window.smartsupp('chat:show');
            }
        };

        if (!allowedPaths.includes(currentPath)) {
            removeChat();
            return undefined;
        }

        window._smartsupp = window._smartsupp || {};
        window._smartsupp.key = 'bef598aedebb1a69759d2300d1421239b3d2a7ec';

        const existingScript = document.getElementById('smartsupp-loader');
        if (existingScript) {
            showChat();
            return undefined;
        }

        const script = document.createElement('script');
        script.id = 'smartsupp-loader';
        script.src = 'https://www.smartsuppchat.com/loader.js?';
        script.async = true;
        script.onload = showChat;
        document.body.appendChild(script);
    }, [pathname]);

    return null;
};

export default SmartsuppChat;
